import { useContext } from 'react';
import { M42HighlightRichtext } from 'ui/components/3-organisms/M42HighlightRichtext/M42HighlightRichtext';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

export const M42HighlightRichtextFeature: React.FC<Umbraco.M42HighlightRichtext> = ({ content }) => {
	const dictionary = useContext(DictionaryContext);
	const { properties } = content;
	const highlightImages = properties?.highlightImages ?? [];

	const sliderDictionary = {
		buttonNext: dictionary.getValue('M42HighlightRichtext.ButtonNext', null, 'next image'),
		buttonPrev: dictionary.getValue('M42HighlightRichtext.ButtonPrev', null, 'previous image'),
	};

	// TODO: need to be optimized to use Slider and its sliderItems
	const mappedSlides = highlightImages?.map((slide) => {
		const { image, text } = slide?.content?.properties || {};

		const slideItem = {
			image: {
				url: image?.url ?? '',
				properties: {
					...image?.properties,
				},
			},
			imageCaption: text ?? '',
		};
		return slideItem;
	});

	if (!properties) {
		return null;
	}
	return <M42HighlightRichtext {...properties} highlightImages={mappedSlides} dictionary={sliderDictionary} />;
};
